import React, { useEffect, useState } from 'react'
import { Button, Card, Col, DatePicker, Descriptions, Divider, Empty, Input, Row, Table, Tabs, Typography } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { useFetch } from '../../../../../../hooks/useFetch'
import CONFIG from '../../../../../../config/env';
const { Title } = CONFIG;

const DATE_PICK_FMT = 'DD-MMM-YYYY';
const DATE_QRY_FMT = 'DD-MM-YYYY';

const h = (row, key) => row?.header?.[key] ?? row?.[key];

const Detail = ({ data }) => {
    const kemasan = data?.detil?.kemasan || [];
    const kontainer = data?.detil?.kontainer || [];
    return (
        <div style={{ padding: 16 }}>
            <Descriptions size="small" bordered column={4}>
                <Descriptions.Item label="ID TPS PLP">{h(data, 'idTpsPlp') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Kode Kantor">{h(data, 'kodeKantor') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Kode TPS Asal">{h(data, 'kodeTpsAsal') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Kode TPS Tujuan">{h(data, 'kodeTpsTujuan') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Call Sign">{h(data, 'callSign') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Nama Angkut" span={3}>{h(data, 'namaAngkut') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl Tiba">{h(data, 'tanggalTiba') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl BC 1.1">{h(data, 'tanggalBc11') || '-'}</Descriptions.Item>
                <Descriptions.Item label="No Surat">{h(data, 'nomorSurat') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl Surat">{h(data, 'tanggalSurat') || '-'}</Descriptions.Item>
                <Descriptions.Item label="User Kirim">{h(data, 'userKirim') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Jenis Transaksi">{h(data, 'jenisTransaksi') || '-'}</Descriptions.Item>
            </Descriptions>
            <Typography.Title level={5} style={{ marginTop: 16 }}>Kemasan</Typography.Title>
            <Table
                size="small"
                pagination={false}
                rowKey={(_, i) => i}
                dataSource={kemasan}
                locale={{ emptyText: 'Tidak ada data kemasan' }}
                columns={[
                    { title: 'Jenis Kemasan', dataIndex: 'jenisKemasan', key: 'jenisKemasan' },
                    { title: 'Jumlah Kemasan', dataIndex: 'jumlahKemasan', key: 'jumlahKemasan' },
                    { title: 'Nomor BL/AWB', dataIndex: 'nomorBlAwb', key: 'nomorBlAwb' },
                    { title: 'Tanggal BL/AWB', dataIndex: 'tanggalBlAwb', key: 'tanggalBlAwb' },
                ]}
            />
            <Typography.Title level={5} style={{ marginTop: 16 }}>Kontainer</Typography.Title>
            <Table
                size="small"
                pagination={false}
                rowKey={(_, i) => i}
                dataSource={kontainer}
                locale={{ emptyText: 'Tidak ada data kontainer' }}
                columns={[
                    { title: 'Nomor Kontainer', dataIndex: 'nomorKontainer', key: 'nomorKontainer' },
                    { title: 'Ukuran Kontainer', dataIndex: 'ukuranKontainer', key: 'ukuranKontainer' },
                    { title: 'Jenis Muat', dataIndex: 'jenisMuat', key: 'jenisMuat' },
                ]}
            />
        </div>
    );
};

export default () => { // eslint-disable-line
    const [filter, setFilter] = useState({ refNumber: '', nomorPlp: '', tanggalPlp: null, kodeGudang: '' });
    const [uri, setUri] = useState(null);
    const [data, loading] = useFetch(uri);
    // API bisa mengembalikan array mentah [{ header, detil }] atau { data: [...] }
    const rows = Array.isArray(data) ? data : (data?.data || []);

    useEffect(() => {
        document.title = `${Title} | Response PLP`;
    }, [])

    const set = (patch) => setFilter((prev) => ({ ...prev, ...patch }));

    const onSearch = () => {
        const q = new URLSearchParams();
        if (filter.refNumber) q.append('refNumber', filter.refNumber.trim());
        if (filter.nomorPlp) q.append('nomorPlp', filter.nomorPlp.trim());
        if (filter.tanggalPlp && moment(filter.tanggalPlp).isValid()) {
            q.append('tanggalPlp', moment(filter.tanggalPlp).format(DATE_QRY_FMT));
        }
        if (filter.kodeGudang) q.append('kodeGudang', filter.kodeGudang.trim().toUpperCase());
        // ganti uri agar useFetch jalan ulang (tambah timestamp cegah cache)
        setUri(`api/v1/plp/get-response-plp?${q.toString()}&timestamp=${moment().unix()}`);
    };

    const columns = [
        {
            selector: (row) => h(row, 'refNumberPlp') || '-',
            name: 'Ref Number',
            id: 'refNumberPlp',
        },
        {
            selector: (row) => h(row, 'nomorPlp') || '-',
            name: 'No PLP',
            id: 'nomorPlp',
        },
        {
            selector: (row) => h(row, 'tanggalPlp') || '-',
            name: 'Tgl PLP',
            id: 'tanggalPlp',
        },
        {
            selector: (row) => `${h(row, 'kodeGudangAsal') || '-'} → ${h(row, 'kodeGudangTujuan') || '-'}`,
            name: 'Asal → Tujuan',
            id: 'rute',
        },
        {
            selector: (row) => h(row, 'nomorBc11') || '-',
            name: 'No BC 1.1',
            id: 'nomorBc11',
        },
        {
            selector: (row) => h(row, 'nomorVoyFlight') || '-',
            name: 'Voy/Flight',
            id: 'nomorVoyFlight',
        },
        {
            selector: (row) => h(row, 'alasanReject') || '-',
            name: 'Alasan Reject',
            id: 'alasanReject',
        },
    ];

    return (
        <>
            <Typography.Title level={5}>Response PLP</Typography.Title>
            <Divider style={{ marginBlock: 8 }} />
            <Tabs defaultActiveKey="response">
                <Tabs.TabPane tab="Response PLP" key="response">
                    <Card size="small" style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                    <Col span={6}>
                        <label>Nomor Reference</label>
                        <Input
                            autoComplete="off"
                            placeholder="cth: UNX3261002000005"
                            value={filter.refNumber}
                            onChange={(e) => set({ refNumber: e.target.value })}
                            onPressEnter={onSearch}
                        />
                    </Col>
                    <Col span={6}>
                        <label>Nomor PLP</label>
                        <Input
                            autoComplete="off"
                            placeholder="cth: 000174"
                            value={filter.nomorPlp}
                            onChange={(e) => set({ nomorPlp: e.target.value })}
                            onPressEnter={onSearch}
                        />
                    </Col>
                    <Col span={6}>
                        <label>Tanggal PLP</label>
                        <DatePicker
                            style={{ width: '100%' }}
                            format={DATE_PICK_FMT}
                            placeholder="Pilih tanggal"
                            value={filter.tanggalPlp}
                            onChange={(date) => set({ tanggalPlp: date })}
                        />
                    </Col>
                    <Col span={6}>
                        <label>Kode Gudang</label>
                        <Input
                            autoComplete="off"
                            placeholder="cth: CENI"
                            value={filter.kodeGudang}
                            onChange={(e) => set({ kodeGudang: e.target.value.toUpperCase() })}
                            onPressEnter={onSearch}
                        />
                    </Col>
                </Row>
                <Row justify="end" style={{ marginTop: 12 }}>
                    <Button type="primary" icon={<SearchOutlined />} loading={loading} onClick={onSearch}>
                        Search
                    </Button>
                </Row>
            </Card>
            <DataTable
                columns={columns}
                data={rows}
                noHeader
                dense
                striped
                persistTableHead
                progressPending={loading}
                highlightOnHover
                expandableRowsComponent={Detail}
                expandableRows
                expandOnRowClicked
                pagination
                paginationServer={false}
                noDataComponent={!uri ? 'Isi filter lalu klik Search untuk menampilkan data' : 'Tidak ada data ditemukan'}
                customStyles={{
                    tableWrapper: {
                        style: {
                            overflowX: 'auto',
                        },
                    },
                }}
            />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Response Batal PLP" key="batal">
                    <Empty description="Response Batal PLP - belum tersedia" style={{ marginBlock: 48 }} />
                </Tabs.TabPane>
            </Tabs>
        </>
    )
}
